import { IUserViewRef } from '../../modules/dmi-verifications/types/dmiTypes';
import { DMI_ACTION_TYPES } from '../../constants/actionTypes/dmiVerificationActionTypes';

interface dmiAction {
    type: string;
    payload?: any;
}

export const INITIAL_STATE = {
    verificationsData: {},
    vlpVerificationsData: {},
    viewRef: null,
    householdIncome: 0,
};

export default(state = INITIAL_STATE, action: dmiAction) => {
    switch (action?.type) {
        case DMI_ACTION_TYPES.GET_DMI_VERIFICATIONS_DATA: {
            return {
                ...state,
                verificationsData: action.payload,
            };
        }
        case DMI_ACTION_TYPES.GET_DMI_VLP_VERIFICATIONS_DATA: {
            return {
                ...state,
                vlpVerificationsData: { ...state.vlpVerificationsData, [action.payload?.applicantGuid]: action.payload?.vlpDetails },
            };
        }
        case DMI_ACTION_TYPES.GET_CURRENT_USER_VIEWREF: {
            return {
                ...state,
                viewRef: action.payload as IUserViewRef,
            };
        }
        case DMI_ACTION_TYPES.GET_HOUSEHOLD_INCOME: {
            return {
                ...state,
                householdIncome: action.payload,
            };
        }
        default:
            return state;
    }
};
